import axios from "axios";

import { setAuthHeaders } from "../utils/setAuthHeaders";
const defaultHeader = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
const adminurl = "https://tramango-core.com/api/";
const API_URL = process.env.REACT_APP_BASEURL;

export const addAdmin = (payload) => {
  const URL = `${API_URL}/admin/create`;

  return axios(URL, {
    method: "POST",
    headers: setAuthHeaders(defaultHeader),
    data: payload,
    withCredentials: true,
  })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// Admin account management (SUPER only). Errors reject with the backend's
// message so callers can show it as-is.
const adminAccountRequest = (method, path, data) =>
  axios(`${API_URL}${path}`, {
    method,
    headers: setAuthHeaders(defaultHeader),
    data,
    withCredentials: true,
  })
    .then((response) => response.data.data)
    .catch((error) => {
      throw new Error(
        error.response?.data?.error || error.message || "Something went wrong"
      );
    });

export const getAdminAccount = (id) =>
  adminAccountRequest("GET", `/admin/accounts/${id}`);

export const updateAdminRole = ({ id, adminType }) =>
  adminAccountRequest("PATCH", `/admin/accounts/${id}/role`, { adminType });

export const resetAdminPassword = (id) =>
  adminAccountRequest("POST", `/admin/accounts/${id}/reset-password`);

export const setAdminStatus = ({ id, disabled }) =>
  adminAccountRequest("PATCH", `/admin/accounts/${id}/status`, { disabled });

export const deleteAccount = (id) =>
  adminAccountRequest("DELETE", `/admin/${id}`);

export const getAllStaff = (payload) => {
  const URL = `${adminurl}userList?user_role=2`;

  return axios(URL, {
    method: "GET",

    headers: setAuthHeaders(defaultHeader),
  })
    .then((response) => response.data.data)
    .catch((error) => {
      console.log(error.response.data.message);
      throw error.response.data.message;
    });
};
